import React from 'react';
import  reactDom from 'react-dom/client';
const { createRoot } = reactDom;
import "./Assets/flaticons/flaticon.css";
import "./Assets/stroke7/style.css";
import "./Theme/theme.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App.js';
import registerServiceWorker from './registerServiceWorker.js';
import ErrorBoundary from './ErrorBoundary.js';
import { store, persistor } from './redux/configureStore.js';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react.js';
import './index.scss';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor}>
          <App/>
      </PersistGate>
    </ReduxProvider>
  </ErrorBoundary>);
registerServiceWorker();
